<template>
	<div class="container business_manage_page">
		<!-- 顶部 -->
		<PageTop></PageTop>
		<!-- 顶部 end -->

		<div style="position: relative;z-index: 9;width: 100%;height: 100%;padding-left: 220px;background: #f7f7f7;">
			<!-- 侧边导航 -->
			<SideNavigation></SideNavigation>
			<!-- 侧边导航 end-->
			
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import PageTop from "./components/page_top.vue"
	import SideNavigation from "./components/side_navigation.vue"
	
	export default {
		components: {
			PageTop,
			SideNavigation
		}
	}
</script>

<style scoped>
	.business_manage_page{ padding: 50px 0 0 0; }
</style>
